import React, { useState, useEffect } from "react";
import "../App.css";
import SEO from "./SEO";
import JobList from "../JobFolder/JobList";
import AllApps from "./AllApps";
function Home() {
  const [activeSection, setActiveSection] = useState("home");
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top-left corner
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll("section");
      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        if (window.scrollY >= sectionTop - 100) {
          setActiveSection(section.getAttribute("id"));
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      window.scrollTo({
        top: section.offsetTop - 80,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="App">
      <SEO
        title="BlueOrbit Technologies - Innovative Mobile App Solutions"
        description="BlueOrbit Technologies creates innovative mobile apps like Status Saver for WhatsApp and Math Formula - Let's Solve It. Download, save, and share statuses easily, and explore math formulas, tricks, quizzes, calculators, and games."
        keywords="WhatsApp status saver, status downloader, BlueOrbit Technologies, mobile apps, Math Formula app, Math formulas, Math tricks, Math quiz, Calculator, Math games"
      />
      <HeroSection />
      {/* <JobList /> */}
      <AllApps />
      <ContactSection />
      <Footer />
    </div>
  );
}

const HeroSection = () => {
  return (
    <section id="home" className="hero">
      <div className="container">
        <h1>Innovative Mobile Solutions</h1>
        <p>
          BlueOrbit Technologies creates powerful, user-friendly mobile
          applications that enhance your digital experience and simplify
          everyday tasks.
        </p>
        <a href="/ourApps" className="btn text-blue bg-white">
          Explore Our Apps
        </a>
      </div>
    </section>
  );
};

const ContactSection = () => {
  return (
    <section id="contact" className="contact">
      <div className="container">
        <h2 className="section-title">Get In Touch</h2>
        <div className="contact-content">
          <div className="contact-info">
            <h3>Contact Information</h3>
            <p>
              <i className="fas fa-envelope"></i>{" "}
              Blueorbittechnologies@gmail.com
            </p>
            {/* <p><i className="fas fa-phone"></i> +1 (555) 123-4567</p> */}
            <p>
              <i className="fas fa-map-marker-alt"></i> Odisha,India
            </p>
          </div>
          <form className="contact-form">
            <input type="text" placeholder="Your Name" />
            <input type="email" placeholder="Your Email" />
            <textarea placeholder="Your Message"></textarea>
            <button type="submit" className="btn">
              Send Message
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>BlueOrbit Technologies</h3>
            <p>
              Creating innovative mobile solutions that enhance your digital
              experience.
            </p>
          </div>
          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li>
                <a href="#home">Home</a>
              </li>
              <li>
                <a href="#about">About</a>
              </li>
              <li>
                <a href="#apps">Our Apps</a>
              </li>
              <li>
                <a href="#contact">Contact</a>
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Follow Us</h3>
            <div className="social-links">
              <a href="#">
                <i className="fab fa-facebook"></i>
              </a>
              <a href="#">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="#">
                <i className="fab fa-linkedin"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2023 BlueOrbit Technologies. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Home;
